/** @format */
import {
    Button,
    ButtonSize,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import { Icon, IconSize } from '@mpb-com/feather/components/atoms/icon';
import { PillLabel } from '@mpb-com/feather/components/atoms/pill-label';
import React, { useContext } from 'react';
import styled from 'styled-components';

import SparkleIcon from '@toucan/client/global/icons/nlx-beta/new-wave.svg';

import { useFeatureFlag } from '@toucan/client/global/feature-flag';
import { MarketContext } from '@toucan/client/global/market';

import { useTooltip } from '@toucan/client/shared/hooks/use-tooltip';

const StyledContainer = styled.div`
    white-space: nowrap;
    margin-right: var(--layout-spacing-16);
    display: none;

    .beta-label {
        font-size: 0.7rem;
        background-color: var(--colors-interactive-focus);
        margin-left: var(--layout-spacing-8);
        padding: var(--layout-spacing-4);
    }

    .button-label {
        display: inline-flex;
        align-items: center;
    }

    .button-container {
        color: var(--colors-text-inverse) !important;
        background-color: var(--colors-surface-accent-inverse) !important;
        border-color: var(--colors-surface-accent-inverse) !important;
        padding: 0 var(--layout-spacing-12);

        .icon svg {
            fill: var(--colors-text-inverse) !important;
        }
    }
`;

export const NlxBetaButton = () => {
    const { activeMarket } = useContext(MarketContext);
    const [bindToolTip, Tooltip] = useTooltip<HTMLDivElement>({
        id: 'smart-search-tooltip',
        closeOnClickAway: true,
    });

    const isEnabled = Boolean(useFeatureFlag('TUR-3337-(nlx-beta)')?.isEnabled);

    if (!isEnabled) return;

    return (
        <StyledContainer
            className="smart-search-link"
            {...bindToolTip}
            data-testid="nlx-beta__header-link"
        >
            <Button
                variant={ButtonVariant.SECONDARY}
                size={ButtonSize.SMALL}
                href={`/${activeMarket.slug}/smart-search`}
                prefix={
                    <Icon size={IconSize.S}>
                        <SparkleIcon />
                    </Icon>
                }
            >
                Try smart search
                <PillLabel className="beta-label">BETA</PillLabel>
            </Button>

            <Tooltip>
                <div>
                    Describe what you&apos;re looking for in natural language
                </div>
            </Tooltip>
        </StyledContainer>
    );
};
